import { Routes } from '@angular/router';
import { authGuard } from './core/guard/auth.guard';

export const routes: Routes = [
    {
        path: '', redirectTo: '/login', pathMatch: "full"
    },
    {
        path: 'login',
        loadComponent: () => import('./screens/auth/login/login.component').then((c) => c.LoginComponent),
        title: 'Login'
    },
    {
        path: '2fa',
        loadComponent: () => import('./screens/auth/two-fa/two-fa.component').then((c) => c.TwoFAComponent),
        title: '2FA'
    },
    {
        path: 'forgotPassword',
        loadComponent: () => import('./screens/auth/forgot-password/forgot-password.component').then(c => c.ForgotPasswordComponent),
        title: 'Forgot Password'
    },
    {
        path: 'activateaccount',
        loadComponent: () => import('./screens/auth/activate-account/activate-account.component').then(c => c.ActivateAccountComponent),
        title: 'Activate Account'
    },
    {
        path: 'resetpassword',
        loadComponent: () => import('./screens/auth/reset-password/reset-password.component').then(c => c.ResetPasswordComponent),
        title: 'Reset Password'
    },
    {
        path: 'dashboard',
        loadChildren: () => import('./dashboard.routes').then(c => c.routes),
        title: 'Dashboard',
        data: { preload: true },
        canActivate: [authGuard]
    },
    // Screens the mobile app opens in its webview: outside the dashboard layout (no sidebar), and
    // flagged `embedded` so AppShellService keeps navigation inside this group.
    {
        path: '',
        loadComponent: () => import('./screens/embedded-shell/embedded-shell.component').then(c => c.EmbeddedShellComponent),
        data: { embedded: true },
        canActivateChild: [authGuard],
        children: [
            {
                path: 'events/:masjidId',
                loadComponent: () => import('./screens/editor-messages/editor-messages-list/editor-messages-list.component').then(c => c.EditorMessagesListComponent),
                title: 'Masjid events'
            },
            {
                path: 'create-post/:masjidId',
                loadComponent: () => import('./screens/events/create-post/create-post').then(c => c.CreatePost),
                title: 'Create Post'
            },
            {
                path: 'edit-post/:id/:masjidId',
                loadComponent: () => import('./screens/events/create-post/create-post').then(c => c.CreatePost),
                title: 'Edit Post'
            },
            {
                path: 'event-detail/:id/:masjidId',
                loadComponent: () => import('./screens/events/event-detail/event-detail').then(c => c.EventDetail),
                title: 'Event Details'
            },
            {
                path: 'master-messages/:orgid',
                loadComponent: () => import('./screens/organization/master-message-list/master-message-list.component').then(c => c.MasterMessageListComponent),
                title: 'Master Messages'
            },
            {
                path: 'addmastermessage/:orgid',
                loadComponent: () => import('./screens/events/create-post/create-post').then(c => c.CreatePost),
                title: 'Add Master Message'
            },
            {
                path: 'editmastermessage/:orgid/:id',
                loadComponent: () => import('./screens/events/create-post/create-post').then(c => c.CreatePost),
                title: 'Edit Master Message'
            },
            {
                path: 'mastereditor-edit-message/:orgid/:id',
                loadComponent: () => import('./screens/events/create-post/create-post').then(c => c.CreatePost),
                title: 'Edit masjid Message'
            },
            {
                path: 'event-detail/:id',
                loadComponent: () => import('./screens/events/event-detail/event-detail').then(c => c.EventDetail),
                title: 'Event Details'
            }
        ]
    },
    {
        path: 'webpayment',
        loadChildren: () => import('./webpayment-routes').then(c => c.WebPaymentRoutes),
        title: 'Web payments',
    },
    {
        path: '**', redirectTo: '/login', pathMatch: "full"
    }
];
